// ===========================================
// Student Waitlist API Functions
// ===========================================
// API calls for student waitlist management endpoints

import { apiClient } from '../services/api';
import { Lesson } from './lessons.api';
import { ProgramLevel } from './admin.api';

// ===========================================
// TYPES
// ===========================================

export interface StudentWaitlistEntry {
  id: string;
  schoolId: string;
  studentId: string;
  lessonId: string | null;
  programLevelId: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  Lesson: Lesson | null;
  ProgramLevel: ProgramLevel | null;
}

export interface AddWaitlistEntryInput {
  lessonId?: string;
  programLevelId?: string;
  notes?: string;
}

// ===========================================
// API CLIENT
// ===========================================

interface ApiResponse<T> {
  status: string;
  data: T;
}

export const studentWaitlistApi = {
  getStudentWaitlist: (studentId: string): Promise<ApiResponse<StudentWaitlistEntry[]>> =>
    apiClient.get(`/students/${studentId}/waitlist`).then((res: any) => res.data),

  addWaitlistEntry: (
    studentId: string,
    data: AddWaitlistEntryInput
  ): Promise<ApiResponse<StudentWaitlistEntry>> =>
    apiClient.post(`/students/${studentId}/waitlist`, data).then((res: any) => res.data),

  removeWaitlistEntry: (studentId: string, entryId: string): Promise<ApiResponse<{ message: string }>> =>
    apiClient.delete(`/students/${studentId}/waitlist/${entryId}`).then((res: any) => res.data),
};
